import { FilterAllExcludeFilterEnum } from '@/bundles/GroupFilters/enums/transactionType';

export const FilterUnsubscribedLabels = {
  [FilterAllExcludeFilterEnum.exclude]: 'Exclude Unsubscribed',
  [FilterAllExcludeFilterEnum.all]: 'All',
  [FilterAllExcludeFilterEnum.filter]: 'Unsubscribed Only',
};

export const FilterUnsubscribedButtonItems = [
  {
    text: FilterUnsubscribedLabels[FilterAllExcludeFilterEnum.exclude],
    value: FilterAllExcludeFilterEnum.exclude,
    btnText: `Exclude \n Unsubscribed`,
  },
  {
    text: FilterUnsubscribedLabels[FilterAllExcludeFilterEnum.all],
    value: FilterAllExcludeFilterEnum.all,
  },
  {
    text: FilterUnsubscribedLabels[FilterAllExcludeFilterEnum.filter],
    value: FilterAllExcludeFilterEnum.filter,
    btnText: `Unsubscribed \n Only`,
  }
];
